import React from 'react';
import { Quote, Star } from 'lucide-react';
import { TESTIMONIALS } from '../data/mock';

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden">
      <div className="thesis-container relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end border-b border-white/8 pb-8 md:pb-12">
          <div className="md:col-span-2">
            <span className="font-mono-label text-[#8E8B85]">(07) — Depoimentos</span>
          </div>
          <div className="md:col-span-10 reveal">
            <h2 className="font-display-tight text-[44px] md:text-[72px] leading-[0.92] text-[#F5F1E8]">
              Quem confia, <span className="font-serif-italic kinetic-grad">volta.</span>
            </h2>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <article key={i}
              className="reveal cursor-hover relative p-8 md:p-10 rounded-[10px] glass hover:-translate-y-1 transition-all duration-500"
            >
              <div className="flex items-center justify-between">
                <Quote size={28} className="text-[#C8FF61]" strokeWidth={1.5} />
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} size={14} className="fill-[#C8FF61] text-[#C8FF61]" />
                  ))}
                </div>
              </div>
              <p className="mt-6 font-serif-italic text-[24px] md:text-[30px] leading-[1.2] text-[#F5F1E8]">
                “{t.text}”
              </p>
              <div className="mt-7 pt-6 border-t border-white/8 flex items-center justify-between">
                <div>
                  <p className="font-display text-[16px] text-[#F5F1E8]">{t.name}</p>
                  <p className="text-[13px] text-[#8E8B85]">{t.role}</p>
                </div>
                <span className="font-mono-label text-[#8E8B85]">0{i + 1}/0{TESTIMONIALS.length}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
